import PropTypes from 'prop-types'

const propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
}

export default propTypes
